import { useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'
import { authApi } from '../api/authApi'
import { useAuthStore } from '../store/authStore'

const PUBLIC_BASE_PATHS = [
  '/login',
  '/reset-password', // /reset-password/$tempToken
  '/complete-setup', // /complete-setup/$token
  '/password-requested', // /password-requested
  '/request-reimbursement', // Public expense form
  '/fix-expense', // Public expense correction form
]

export const useAuthInit = () => {
  const setUser = useAuthStore((state) => state.setUser)
  const logout = useAuthStore((state) => state.logout)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  const router = useRouter()
  const currentPathname = router.state.location.pathname

  useEffect(() => {
    const isPublicPath = PUBLIC_BASE_PATHS.some((path) =>
      currentPathname.startsWith(path),
    )

    if (!isAuthenticated && isPublicPath) {
      console.log(
        `Skipping global auth check on public path: ${currentPathname}`,
      )
      return
    }

    // Only run on initial mount
    const checkAuth = async () => {
      try {
        const res = await authApi.me()
        setUser(res.data.user)
      } catch (error: any) {
        await logout()
        // router.navigate({ to: '/login' })
      }
    }
    if (!isAuthenticated) {
      checkAuth()
    }
  }, [])
}
